export class SearchEmailFaxLogItem {
    public customer: number[] = [];
    public equipment: number[] = [];
    public LogSentType: number = 0;
    public Username!:string;
    public Email!:string;
    public LabNumber!:string;
    public startDate!: string;
    public endDate!: string;
    PageNo!:number; 
    PageSize!: number;
}

export class EmailFaxLogSearchResult {
    public TotalRecords: number;
    public emailFaxLogResult: EmailFaxLogRowViewModel[];
  }
  
  export class EqAndInspectionIds{
    public EquipmentId:number;
    public InspectionId:number;
  }
  export class EmailFaxLogRowViewModel {
    constructor(
      public Dealer: string,
      public Examiner: string,
      public CustomerName: string,
      public Evaluation: string,
      public Eval_:string,
      public InspectionDate: Date,
      public JobsiteName: string,
      public Make: string,
      public Model: string,
      public SerialNumber: string,
      public UnitNumber: string,
      public EquipmentID:number,
      public IsMailSent:boolean
      ) { }
  }
  
  export class EmailFaxLogSearchRequest {
    constructor(
      public PageNumber: number,
      public InspectionsPerPage: number,
      public SearchItems: SearchEmailFaxLogItem,
      public OrderBy: EmailLogOrderBy,
    ) {}
  }

  export class EmailLogOrderBy {
    constructor( sortOption: SortOptions, selected: boolean = false){
      this.selected = selected;
      this.sortOption = sortOption;
    }
    public sortOption: SortOptions;
    public selected: boolean;
  }

  export enum SortOptions {
    Email,
    Username,
    SerialNumber,
    UnitNumber,
    Customer,
    LabNumber,
    LogDate,
    LogTime,
    IsMailSent,
  }
  
  
  export enum ViewedInspectionTypes {
   GeneralInspection,
   UnsyncInspection,
   RepairEstimates,
  }
